import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LISTING_UPDATE_PROPERTY_CONDITION_REPORT,
} from 'api/actionTypes';

export default async function updatePropertyConditionReport(
  { state, apiClient },
  {
    marketingListingId,
    propertyConditionOverall,
    propertyConditionUrl,
    propertyConditionDateInspected,
  }
) {
  typeCheck('marketingListingId::PositiveNumber', marketingListingId);
  typeCheck('propertyConditionOverall::String', propertyConditionOverall);
  typeCheck('propertyConditionUrl::String', propertyConditionUrl);
  typeCheck('propertyConditionDateInspected::DateString', propertyConditionDateInspected);

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_UPDATE_PROPERTY_CONDITION_REPORT,
    state: state,
    payload: {
      marketingListingId,
      propertyConditionOverall,
      propertyConditionUrl,
      propertyConditionDateInspected,
    },
  });
}
